import React from 'react';
import ServicePageTemplate from './ServicePageTemplate';
import { webDevelopmentConfig } from './servicePageConfigs';

const ServiceDetails = () => <ServicePageTemplate {...webDevelopmentConfig} />;

export default ServiceDetails;
